var _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 380.84 376.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.33,294.36a63.45,63.45,0,0,1-74.68-.08L0,182.93V331.36A44.74,44.74,0,0,0,44.74,376.1H336.1a44.74,44.74,0,0,0,44.74-44.74V182.93Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46,158.64l62.32,46.19V69.25H310.06V204.83l62.32-46.19A17,17,0,0,0,379.23,145v-6.61a16.94,16.94,0,0,0-6.49-13.34l-28.61-22.44-.68-33.51a35,35,0,0,0-35-34.29h-61A21,21,0,0,1,233,29.08L211.1,8.26a30,30,0,0,0-41.36,0l-21.9,20.82a21,21,0,0,1-14.41,5.75H72.38a35,35,0,0,0-35,34.29l-.68,33.51L8.1,125.07a16.94,16.94,0,0,0-6.49,13.34V145A17,17,0,0,0,8.46,158.64Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 118.38,
    y: 123.28,
    width: 143.16,
    height: 29.6,
    rx: 0.86
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 118.38,
    y: 197.61,
    width: 143.16,
    height: 29.6,
    rx: 0.86
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.ec7793abc3a6878310f0938c13bcd115.svg";
export { ForwardRef as ReactComponent };